import React from "react"
import Introduce_web from "./introduce_web";
import Introduce_mobile from "./introduce_moblie";

export default function Introduce() {
    return (
    <div className='' >
        <div className='hidden md:block'>
            <Introduce_web />
        </div>
        <div className='md:hidden'>
            <Introduce_mobile />
        </div>
    </div> 
    );
}


